var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Clear Cart?","first-button-text":"keep cart","second-button-text":"YES","dark-theme":_vm.darkTheme,"is-loading":_vm.isLoading,"first-button-action":_vm.firstButtonAction,"second-button-action":_vm.secondButtonAction},on:{"close":_vm.closeModal}},[_c('div',[_vm._v(" All items will be removed ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }